import { FC } from 'react';
import { useRouter } from 'next/router';
import { Accordion, Modal, Types, Link } from '@marriott/mi-ui-library';
import { StyledEventSummaryModal } from './EventSummaryModal.styles';
import { EventSummaryModalProps } from './EventSummaryModal.types';
import { EventProfileSummary } from './EventProfileSummary';
import { EventDetailsSummary } from './EventDetailsSummary';
import { ContactInfoSummary } from './ContactInfoSummary';

export const EventSummaryModal: FC<EventSummaryModalProps> = props => {
  const { labels, show, onCloseModal } = props;
  const { eventSummary, currentPageNo, currentStep } = labels;
  const { eventSummaryLabel, editCtaLabel, eventProfile, eventDetails, contactInformation } = eventSummary;

  const router = useRouter();

  const sections = [
    eventProfile.eventProfileLabel,
    eventDetails.eventDetailsLabel,
    contactInformation.contactInformationLabel,
  ].map((section, index) => {
    return {
      number: (index + 1).toString(),
      name: section,
      editUrl: index === 0 ? eventProfile.editCtaLink : index === 1 ? eventDetails.editCtaLink : '',
    };
  });

  const handleEdit = (event: React.MouseEvent, editUrl: string) => {
    event.preventDefault();
    event.stopPropagation();
    router.push(editUrl);
  };

  const displayEventSummary = (stepNumber: string) => {
    if (stepNumber === '1') {
      return <EventProfileSummary labels={eventProfile} />;
    } else if (stepNumber === '2') {
      return <EventDetailsSummary labels={eventDetails} />;
    } else if (stepNumber === '3') {
      return <ContactInfoSummary labels={contactInformation} />;
    }
    return null;
  };

  return (
    <StyledEventSummaryModal>
      <Modal
        modalId="eventSummaryModal"
        role="dialog"
        labelledBy="eventSummaryModal"
        show={show}
        popupOpenState={show}
        handleBlur={true}
        disableScrollOnBody={true}
        setPopupOpenState={onCloseModal}
        onClose={onCloseModal}
      >
        <Modal.Header
          headingTagElement={Types.tags.div}
          labelText={eventSummaryLabel}
          popupHeaderOnCLoseFunc={onCloseModal}
        ></Modal.Header>
        <Modal.Body className="custom-scrollbar">
          <div className="mx-2 my-3">
            {sections.map(section => {
              return (
                <div className="mb-4">
                  <div className="t-overline-normal mb-2">{currentStep.replace('{x}', section.number)}</div>
                  <div className="accordion-container">
                    <Accordion
                      id={`section${section.number}`}
                      isOpen={currentPageNo === section.number}
                      enableFullWidthHeader={true}
                      headerChildren={
                        <div className="accordion-header">
                          <div className="t-subtitle-l">{section.name}</div>
                          {section.number < currentPageNo && (
                            <Link
                              text={editCtaLabel}
                              linkClassName="edit-cta"
                              linkHref="#"
                              callback={event => handleEdit(event, section.editUrl)}
                            ></Link>
                          )}
                        </div>
                      }
                      headerAriaLabel={section.name}
                    >
                      {displayEventSummary(section.number)}
                    </Accordion>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>
    </StyledEventSummaryModal>
  );
};
